import React, { Component } from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import { Link, Navigate } from "react-router-dom";
import AuthService from './AuthService';
import './Events.css'
import ActionCable from 'action-cable-react-jwt';
import 'bootstrap/dist/css/bootstrap.min.css';

class Events extends Component {
  state = { items: [] , current_page: 0, total_items: 0, total_pages: 0, items_per_page: 0 }
      
  componentDidMount() {
    const bearerToken = new AuthService().getToken();
    if(bearerToken != null) {
      const token = bearerToken.substring(7, bearerToken.length);
	  
	  let { page } = this.props;
	  if(page === undefined) {
	  	page = 1
	  }
	  	  	  	  	  	  
      window.fetch(process.env.REACT_APP_EVENTS+'/?current_page=' + page, {
        method: 'GET',
        headers: {
          Authorization: bearerToken
        }
      }).then(data => {
        data.json().then(res => {
          this.setState({ items: res.events, current_page: res.current_page, total_items: res.total_items, total_pages: res.total_pages, items_per_page: res.items_per_page })
        })
      })

      const cable = ActionCable.createConsumer(process.env.REACT_APP_CABLE,token)
      this.sub = cable.subscriptions.create('EventsChannel', {
        received: this.handleReceiveNewEvent
      })
    }
  }

  handleReceiveNewEvent = (event) => {
    this.setState({ items: this.state.items.concat(event) })
  }

  handleDeleteEvent = (eventId) => {
    if (window.confirm('Are you sure you want to delete this event?')) {
      const bearerToken = new AuthService().getToken();
      if(bearerToken != null) {
        window.fetch(process.env.REACT_APP_EVENTS + '/' + eventId, {
          method: 'DELETE',
          headers: {
            Authorization: bearerToken,
          },
        })
          .then((response) => {
            if (response.status === 204) {
              this.setState({ items: this.state.items.filter(item => item.id !== eventId) });
            } else {
              throw new Error('Failed to delete event');
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }

    }
  }

  handleDownloadFile = (eventName, eventId) => {
    const bearerToken = new AuthService().getToken();
    if(bearerToken != null) {
      window.fetch(process.env.REACT_APP_EVENTS + '/' + eventId + '/payload', {
        method: 'GET',
        headers: {
          Authorization: bearerToken
        }
      })
        .then((response) => {
          if (response.ok) {
            return response.blob();
          } else {
            throw new Error('Failed to download file');
          }
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          if (eventName.toLowerCase() === 'vrgbd-app') {
            link.setAttribute('download', eventId + '.zip');
          } else {
            link.setAttribute('download', eventId);
          }
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  sortByFileDatePrefix(a,b) {
    if (a.created_at > b.created_at) return -1;
    if (b.created_at > a.created_at) return 1;
    return 0;
  }

  render() {
    const options = {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: 'numeric', second: 'numeric',
      hour12: false, timeZoneName: 'short', timeZone: 'UTC'
    };
    if((new AuthService()).loggedIn()) {
    return (
      <>
      <Container>
        <style>
            {`
              th {
                text-align: center;
                width: auto;
              }
              table {
                table-layout: auto;
                width: auto;
              }
            `}
        </style>
        <Table striped bordered width="100%">
          <thead>
            <tr>
			  <th><a href={`/events/1`}>First</a></th>
			  {this.state.current_page-1 <= 0 ? <th></th> : <th><a href={`/events/${this.state.current_page-1}`}>Prev</a></th>}
			  <th colSpan="4">{this.state.total_items} total events (page {this.state.current_page} of {this.state.total_pages})</th>
			  {this.state.current_page+1 > this.state.total_pages ? <th></th> : <th><a href={`/events/${this.state.current_page+1}`}>Next</a></th>}
			  <th><a href={`/events/${this.state.total_pages}`}>Last</a></th>
			  <th><Link to='/admins'>tokens</Link>&nbsp;&nbsp;&nbsp;&nbsp;<Link to='/logout'>logout</Link></th>
			</tr>
            <tr>
              <th>Created at</th>
              <th>UUID</th>
              <th>Name</th>
              <th>TCI</th>
              <th>Size</th>
              <th>Device ID</th>
              <th>Device</th>
              <th>IP address</th>
              <th>actions</th>
            </tr>
          </thead>
          <tbody>
          {this.state.items.sort((a,b) => {
            if (b.created_at < a.created_at) return -1;
            if (a.created_at < b.created_at) return 1;
            return 0;
          }).slice(0,this.state.items_per_page).map((item) => {
            return (
            <tr key={item.id}>
              <td>{Intl.DateTimeFormat('en-GB', options).format(Date.parse(item.created_at))}</td>
              <td className="ellipsis"><span>
                <a href="#" onClick={() => this.handleDownloadFile(item.name, item.id)} title="Click to download">{item.id}</a></span>
              </td>
              <td className="ellipsis"><span>{item.name}</span></td>
              <td>
				<span className="text-overflow-dynamic-container">
				<span className="text-overflow-dynamic-ellipsis" title={item.tci}>
				{ item.tci.includes('logfile')
                ? <Link to={'logfile/' + item.id}>logfile</Link>
                : (item.processed ? <Link to={'datafile/' + item.id} title={item.tci}>datafile</Link> : item.tci)
                }
				</span>
			    </span>
			  </td>
              <td className="ellipsis"><span>{item.size}</span></td>
              <td className="ellipsis"><span title={item.deviceid}>{item.deviceid}</span></td>
              <td className="ellipsis"><span title={item.opsystem+" "+item.opversion+" "+item.model+" "+item.manufacturer}>{item.opsystem}&nbsp;{item.opversion}&nbsp;{item.model}&nbsp;{item.manufacturer}</span></td>
              <td className="ellipsis"><span title={item.ipaddress}>{item.ipaddress}</span></td>
              <td>
                <Button variant="danger" onClick={() => this.handleDeleteEvent(item.id)}>
                    <span aria-hidden="true">&times;</span>
                </Button>
              </td>
            </tr>);})}
          </tbody>
        </Table>
      </Container>
      </>
    )
  }
  return (
    <Navigate to='/login' />
  )
  }
}

export default Events
